export { default } from '../sewpatgallery/SewpatGallery';



// WEBPACK FOOTER //
// ./src/components/async/SewpatGallery.js